<script>
  import { onMount, createEventDispatcher } from "svelte";
  import queryString from "query-string";

  let element;
  let search;
  let autocomplete;
  let locationBias;
  let value = "";
  let locationBounds;

  const emit = createEventDispatcher();

  function geolocate() {
    if (navigator.geolocation && window.google) {
      navigator.geolocation.getCurrentPosition(function (position) {
        var geolocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        var circle = new google.maps.Circle({
          center: geolocation,
          radius: position.coords.accuracy,
        });

        autocomplete.setBounds(circle.getBounds());
        locationBounds = circle.getBounds();
      });
    }
  }

  function searchResults(places) {
    if (places && places.length && places[0].place_id) {
      emit("result", places[0]);
    } else {
      emit("result", null);
    }
    search.value = "";
  }

  function initAutocomplete() {
    if (!autocomplete && window.google) {
      try {

        autocomplete = new google.maps.places.SearchBox(search);
        autocomplete.addListener("places_changed", () =>
          searchResults(autocomplete.getPlaces())
        );

      } catch (error) {

      }

      try {
        let queryParams = queryString.parse(window.location.search);
        if (queryParams.q) {

          var service = new google.maps.places.PlacesService(
            document.createElement("div")
          );
          geolocate();
          service.findPlaceFromQuery(
            {
              query: queryParams.q,
              fields: ["name", "place_id"],
              locationBias: locationBounds,
            },
            searchResults
          );
        }
      } catch (error) {

      }
    }
  }

  onMount(() => {
    initAutocomplete();
  });
</script>

<style>
  .container {
    display: flex;
    justify-content: center;
    line-height: 40px;
    width: 100%;
  }
  .search-box {
    margin: 10px;
    border-radius: 0;
    border: 1px solid black;
    border-radius: 0;
    margin: 0;
    font-size: 16px;
    width: 480px;
    padding: 8px;
    border: 3px solid rgba(61, 59, 59, 1);
    display: block;
  }

  @media only screen and (max-width: 570px) {
    .search-box {
      width: calc(100% - 50px);
    }
  }

  .search-button {
    font-weight: bold;
    border-radius: 0;
    margin: 0;
    padding: 1px 20px;
    margin-left: 30px;
    border: 0;
    background-color: #3d3b3b;
    color: white;
    cursor: pointer;
  }

  .search-button:hover {
    background-color: #f0913f;
    transition: background-color 0.4s ease 0s;
  }
</style>

<svelte:window on:maps-loaded={initAutocomplete} />

<div bind:this={element} class="container search-box-container">
  <input
    type="text"
    bind:this={search}
    class="search-box"
    placeholder="Search by building name or address"
    autocomplete="false"
    on:focus={geolocate} />
  <!-- button class="search-button" on:click={() => autocomplete.getPlaces()}>
      FIND MY LOCATION
    </button -->
</div>
